<template>
  <div class="workspace-table-wrapper mt-5">
    <div class="page-container">
      <div>
        <WorkspacesTable
          v-if="workspaces && workspaces.length > 0"
          :is-loaded-ws-list="isLoadedWsList"
          :items="formattedItems"
          :headers="headers"
          :next-token="nextToken"
          @getWorkspaces="getWorkspaces"
          @onManageWorkspace="onManageWorkspace" />
        <div
          v-else
          class="empy-list-msg">
          There are no custom workspaces yet
        </div>
      </div>
    </div>
    <WorkspacesDialog
      :is-open="isWorkspacesDialogOpen"
      :current-edit-workspace="currentEditWorkspace"
      @setIsOpen="(val)=> isWorkspacesDialogOpen = val"
      @onUpdate="onWorkspaceUpdate" />
  </div>
</template>
<script>
import API from '@/services/GraphQl';
import WorkspacesTable from '@/components/Workspaces/WorkspacesTable';
import WorkspacesDialog from '@/components/Workspaces/WorkspacesDialog';
import {
  mapActions,
  mapGetters,
  mapMutations,
} from 'vuex';
export default {
  name: 'Workspaces',
  components: {
    WorkspacesTable,
    WorkspacesDialog,
  },
  data: () => ({
    workspaces: [],
    isWorkspacesDialogOpen: false,
    currentEditWorkspace: null,
    isLoadedWsList: false,
    headersV2: [
      {
        text: 'Workspace name',
        value: 'name',
        sortable: false,
        width: 250,
      },
      {
        text: 'Plan',
        value: 'type',
        sortable: false,
        width: 140,
      },
      {
        text: 'Licenses',
        value: 'licenses',
        sortable: false,
        width: 85,
      },
      {
        text: 'Creator name',
        value: 'creator.name',
        sortable: false,
      },
      {
        text: 'Pages',
        value: 'allowPages',
        sortable: false,
        align: 'center',
        width: 75,
      },
      {
        text: '',
        value: 'action',
        sortable: false,
        align: 'right',
        width: 50,
      },
    ],
    nextToken: null,
    limit: 10,
    limitV2: 100,
  }),
  computed: {
    ...mapGetters({
      useSearchWorkspaceList: 'SiteConfiguration/useSearchWorkspaceList',
    }),
    renderLimit() {
      if (this.useSearchWorkspaceList) {
        return this.limitV2;
      }
      return this.limit;
    },
    formattedItems() {
      return this.workspaces.map((w)=>{
        return {
          ...w,
          licenses: this.formatLicensesString(w),
        };
      });
    },
    headers() {
      return this.mappedHeadersV2;
    },
    mappedHeadersV2() {
      return this.headersV2;
    },
  },
  async mounted() {
    this.spinner(true);
    await this.getWorkspaces();
    this.spinner(false);
  },
  methods: {
    ...mapMutations(['spinner']),
    ...mapActions({
      handleError: 'handleError',
    }),
    async loadFirstlyWorkspaces() {
      const { nextToken, limit } = this;
      const { data } = await API.listWorkspaces({
        limit: this.renderLimit,
        nextToken,
      });
      this.workspaces = data.response.data;
      this.nextToken = data.response.nextToken;
      if (this.useSearchWorkspaceList) {
        this.getWorkspaces();
      }
    },
    async loadAppendWorkspaces() {
      const { nextToken, limit } = this;
      const { data } = await API.listWorkspaces({
        limit: this.renderLimit,
        nextToken,
      });
      this.workspaces = [...this.workspaces, ...data.response.data] ;
      this.nextToken = data.response.nextToken;
      if (this.useSearchWorkspaceList) {
        this.getWorkspaces();
      }
    },
    async getWorkspaces() {
      try {
        if (this.workspaces.length === 0) {
          this.loadFirstlyWorkspaces();
          return;
        }
        const { nextToken } = this;
        if (nextToken !== null) {
          this.loadAppendWorkspaces();
          return;
        }
        if (!nextToken) {
          this.isLoadedWsList = true;
        }
      } catch (err) {
        console.log(err);
      }
    },
    onManageWorkspace(workspace) {
      this.currentEditWorkspace = workspace;
      this.isWorkspacesDialogOpen = true;
    },
    formatLicensesString(workspace) {
      if (workspace.type === 'free') {
        return `${workspace.usedLicenses} / ${workspace.freeLicenses}`;
      } else {
        return `${workspace.usedLicenses} / ${workspace.premiumLicenses}`;
      }
    },
    async onWorkspaceUpdate(value) {
      const {
        type, allowPages, verified,
        freeLicenses, guestLicenseLimit, premiumLicenses,
        unlimitedUsers = false,
      } = value ?? {
      };
      try {
        const { id: workspaceId } = this.currentEditWorkspace;
        const requestName = 'manageWorkspaceV2';
        this.spinner(true);
        await API[requestName]({
          workspaceId,
          type,
          premiumLicenses,
          freeLicenses,
          guestLicenseLimit,
          unlimitedUsers,
          allowPages,
        });
        await API.setWorkspaceVerified({
          workspaceId,
          verified,
        });
        this.applyChanges({
          workspaceId,
          type,
          freeLicenses,
          guestLicenseLimit,
          premiumLicenses,
          unlimitedUsers,
          verified,
          allowPages,
        });
        const currType = this.currentEditWorkspace.type;
        if (currType != type) {
          API.modifyWorkspaceSubscription({
            workspaceId,
            currWorkspaceType: currType,
            newWorkspaceType: type,
          });
        }
        this.isWorkspacesDialogOpen = false;
      } catch (err) {
        this.handleError(err);
      } finally {
        this.spinner(false);
      }
    },
    applyChanges({
      workspaceId,
      freeLicenses,
      premiumLicenses,
      guestLicenseLimit,
      unlimitedUsers,
      allowPages,
      type,
      verified,
    }) {
      if (!workspaceId) {
        throw new Error('Empty workspace is provided.');
      }
      this.workspaces = this.workspaces.map(w => {
        return w.id === workspaceId ? {
          ...w,
          type,
          freeLicenses,
          guestLicenseLimit,
          premiumLicenses,
          unlimitedUsers,
          allowPages,
          verified,
        } : w;
      });
    },
  },
};
</script>
<style scoped lang="scss">
  .empy-list-msg{
    display:flex;
    justify-content:center;
    align-items:center;
    color:grey;
    margin-top: 50px;
  }
</style>
